import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  deteleCustomDomain,
} from 'redux/settings/actions';

import CommonPopup from 'components/common/CommonPopup';
import CommonModal from 'components/elements/modals/CommonModal';

import './CustomDomainInfo.css';

const CustomDomainInfo = ({ me, deteleCustomDomain }) => {

  const [confirmModal, setConfirmModal] = useState(false);

  if (!me || (me && !me.custom_domain)) {
    return null;
  }

  const onRemoveDomain = () => {
    deteleCustomDomain(me.custom_domain.id);
    setConfirmModal(false);
  };

  return (
    <Translation>
      {(t) => (
        <div className="custom-domain-info__component">
          <div className="custom-domain-info-wrapper">
            <div className="field-label">
              {me && me.custom_domain && me.custom_domain.is_verified ?
                <span>{t("Connected custom domain:")}</span>
                :
                <span className="grey-text">{t("Enter the domain you want to connect to your HeyLink.me page")}</span>
              }
            </div>

            <div className="pseudo-field">
              <div className="pseudo-field-wrapper">
                {me && me.custom_domain && me.custom_domain.is_verified ?
                  <a
                    href={`https://${me.custom_domain.domain}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span>{me.custom_domain.domain}</span>
                  </a>
                  :
                  <section>
                    <span>{me.custom_domain.domain}</span>
                  </section>
                }

                <CommonPopup
                  successIcon
                  type="success"
                  triggerClassName="field-wrapper-icon"
                >
                  {me && me.custom_domain && !me.custom_domain.is_verified ? t("Valid domain name") : t("Domain is verified & connected")}
                  {/* Domain is verified &amp; connected */}
                </CommonPopup>
              </div>

              <div
                className="pseudo-field-remove-button"
                onClick={() => { setConfirmModal(true); }}
                role="button"
                tabIndex={-1}
              >
                <div className="icon" />
                <div className="text">{t("Remove")}</div>
              </div>

            </div>
          </div>

          <CommonModal
            className="custom-domain-remove-confirm-modal__component"
            open={confirmModal}
            onClose={() => { setConfirmModal(false); }}
          >
            <div className="wrapper">
              <div className="text-content">
                <b>{t("Attention! Your custom domain will be disconnected")}<br />
                   {t("from your HeyLink.me page. You can’t undo this action.")}</b><br />
                   {t("Are you sure you would like to proceed?")}
              </div>
              <div className="buttons-block">
                <div
                  className="modal-button confirm"
                  onClick={() => { onRemoveDomain(); }}
                  role="button"
                  tabIndex={-1}
                >
                  {t("Yes, remove")}<br /> {t("this domain name")}
                </div>

                <div
                  className="modal-button"
                  onClick={() => { setConfirmModal(false); }}
                  role="button"
                  tabIndex={-1}
                >
                  {t("Not now")}
                </div>
              </div>
            </div>
          </CommonModal>

        </div>
      )}
    </Translation>
  );
};

CustomDomainInfo.propTypes = {
  me: PropTypes.object,
  deteleCustomDomain: PropTypes.func,
};
CustomDomainInfo.defaultProps = {
  me: null,
  deteleCustomDomain: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    deteleCustomDomain,
  },
)(CustomDomainInfo);
